import { render, staticRenderFns } from "./ServicesPage.vue?vue&type=template&id=da73e15c&scoped=true&"
import script from "./ServicesPage.vue?vue&type=script&lang=js&"
export * from "./ServicesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da73e15c",
  null
  
)

export default component.exports